<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-12 bg-secondaryL p-3 my-auto">
        <h4 class="d-inline">Bank Details</h4>
        <a href="#" @click="refreshTransfer">
          <img
            src="@/assets/img/refresh_icon.png"
            class="my-auto float-right d-inline"
            alt="Refesh Icon"
          />
        </a>
      </div>
    </div>
    <div class="row pt-2 pb-4">
      <div class="col-sm-6">
        <div class="row mt-3">
          <div class="col-12 col-xl-4">
            <label>
              Account Name:
              <span v-if="!$v.bankDetails.AccountName.required">*</span>
            </label>
          </div>
          <div class="col-12 col-xl-8 mt--20">
            <input
              type="text"
              maxlength="50"
              class="form-control underline mt-2"
              name="Account Name"
              required
              v-model="bankDetails.AccountName"
              pattern="^[A-Za-z -]+$"
              :class="{ 'is-invalid': submitted && $v.bankDetails.AccountName.$error }"
            />
            <div class="invalid-feedback" v-if="submitted && !$v.bankDetails.AccountName.required">
              Please provide an
              account name.
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-xl-4">
            <label>
              Account Number:
              <span v-if="!$v.bankDetails.AccountNumber.required">*</span>
            </label>
          </div>
          <div class="col-12 col-xl-8 mt--20">
            <input
              class="form-control underline mt-2"
              name="Account Number"
              type="text"
              pattern="\d*"
              step="1"
              maxlength="8"
              v-model="bankDetails.AccountNumber"
              @keypress="numericInput($event, index)"
              :class="{ 'is-invalid': submitted && $v.bankDetails.AccountNumber.$error }"
            />
            <div
              class="invalid-feedback"
              v-if="submitted && !$v.bankDetails.AccountNumber.required"
            >
              Please provide an
              account number.
            </div>
            <div class="invalid-feedback" v-if="!$v.bankDetails.AccountNumber.minLength">
              Account number must contain at
              least
              {{$v.bankDetails.AccountNumber.$params.minLength.min}} digits.
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-xl-4">
            <label>
              Sort Code:
              <span v-if="!$v.bankDetails.SortCode.required">*</span>
            </label>
          </div>
          <div class="col-12 col-xl-8 mt--20">
            <input
              class="form-control underline mt-2"
              name="Account Sort Code"
              type="text"
              pattern="\d*"
              step="1"
              maxlength="6"
              v-model="bankDetails.SortCode"
              @keypress="numericInput($event, index)"
              :class="{ 'is-invalid': submitted && $v.bankDetails.SortCode.$error }"
            />
            <div class="invalid-feedback" v-if="submitted && !$v.bankDetails.SortCode.required">
              Please provide a sort
              code.
            </div>
            <div class="invalid-feedback" v-if="!$v.bankDetails.SortCode.minLength">
              Sort code must contain
              {{$v.bankDetails.SortCode.$params.minLength.min}} digits.
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-xl-4">
            <label>
              Organisation:
              <span v-if="!$v.bankDetails.DdOrganisationId.required">*</span>
            </label>
          </div>
          <div class="col-12 col-xl-8">
            <b-form-select
              v-model="bankDetails.DdOrganisationId"
              class="form-control"
              :class="{ 'is-invalid': submitted && $v.bankDetails.DdOrganisationId.$error }"
              name="selection"
              required
            >
              <option
                v-for="(organisation, index) in filteredOrganisations"
                :key="index"
                :value="organisation.id"
              >{{organisation.name}}</option>
            </b-form-select>
            <div
              class="invalid-feedback"
              v-if="submitted && !$v.bankDetails.DdOrganisationId.required"
            >Please select an organisation.</div>
          </div>
        </div>
      </div>
    </div>
    <!-- bank row closed -->
    <div class="modal-footer">
      <button type="submit" class="btn btn-hc float-right" @click="back">
        <i class="fas fa-caret-left"></i> Back
      </button>
      <button type="submit" class="btn btn-hc float-right" @click="next">
        Next
        <i class="fas fa-caret-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import _ from "underscore";

import Vue from "vue";

export default {
  data() {
    return {
      submitted: false,
    };
  },
  validations() {
    return {
      bankDetails: {
        AccountName: {
          required,
          maxLength: maxLength(50),
        },
        AccountNumber: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(8),
        },
        SortCode: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(6),
        },
        DdOrganisationId: {
          required,
        },
      },
    };
  },
  computed: {
    bankDetails: {
      get() {
        return this.$store.state.transfer.transferBankDetails;
      },
      set(details) {
        this.$store.commit("updateTransferBankDetails", details);
      },
    },
    organisations() {
      return Vue.config.honeycomb.ddbot.organisations;
    },
    transferServices() {
      return this.$store.state.transfer.transferServices;
    },
    serviceTypes() {
      let serviceTypes = [];
      this.transferServices.forEach((service) => {
        serviceTypes.push(service.Service.ServiceType);
      });
      return _.uniq(serviceTypes);
    },
    filteredOrganisations() {
      if (Vue.config.honeycomb.filterByDdOrganisationId) {
        let regex = "";
        for (let serviceType of this.serviceTypes) {
          regex += serviceType + "|";
        }
        regex = regex.substring(0, regex.length - 1);

        return _.filter(this.organisations, (organisation) => {
          return new RegExp(regex, "i").test(organisation.name);
        });
      } else {
        return this.organisations;
      }
    },
  },
  methods: {
    refreshTransfer() {
      this.submitted = false;
      this.$store.commit("refreshTransfer");
    },
    next() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        setTimeout(() => {
          this.$http
            .post(
              "https://" +
                Vue.config.honeycomb.ddbot.domain +
                "/api/v1/lodgements/validate",
              {
                AccountName: this.bankDetails.AccountName,
                AccountNumber: this.bankDetails.AccountNumber,
                SortCode: this.bankDetails.SortCode,
              },
              {
                withCredentials: true,
              }
            )
            .then((response) => {
              if (
                response.data.hasOwnProperty("IsValid") &&
                response.data.IsValid == false
              ) {
                this.$snotify.warning(`Invalid bank details.`);
              } else {
                this.$snotify.success(`Bank details validated.`);
                this.submitted = false;
                this.$emit("next");
              }
            })
            .catch((error) => {
              // Error
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // this.submitStatus = 'Error'
                if (error.response.data.MoreInformation.length > 0) {
                  error.response.data.MoreInformation.forEach((e) => {
                    this.$snotify.error(`${e.Error}`, {
                      timeout: 0,
                      closeOnClick: true,
                    });
                  });
                } else {
                  this.$snotify.error(
                    `${error.response.data.UserDescription}`,
                    {
                      timeout: 0,
                      closeOnClick: true,
                    }
                  );
                }
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                // this.submitStatus = 'Error'
                this.$snotify.error(`No response received.`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              } else {
                // Something happened in setting up the request that triggered an Error
                // this.submitStatus = 'Error'
                this.$snotify.error(`${error.message}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            });
        });
      }
    },
    back() {
      this.submitted = false;
      this.$emit("back");
    },
    numericInput($event) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode > 47 && keyCode < 58) {
        return;
      }
      return $event.preventDefault();
    },
  },
};
</script>
